export default [
  {
    path: '/main/garageaccrediteds',
    meta: {
      tag: 'list_garageaccredited',
      name: 'Oficinas Credenciadas',
      breadcrumb: 'Oficinas Credenciadas'
    },
    component: () => import(/* webpackChunkName: "users-list" */ '@/views/main/settings/test-registers/garageaccredited/Index.vue'),
    children: [
      {
        path: '',
        name: 'listgarageaccrediteds',
        meta: {
          tag: 'list_garageaccredited',
          menu: 'settings',
          name: 'Oficinas Credenciadas'
        },
        component: () => import(/* webpackChunkName: "users-list" */ '@/views/main/settings/test-registers/garageaccredited/List.vue')
      },
      {
        path: '/main/garageaccredited/add',
        name: 'addgarageaccredited',
        meta: {
          tag: 'add_garageaccredited',
          menu: 'settings',
          name: 'Adicionar | Oficina Credenciada',
          breadcrumb: 'Adicionar Oficina Credenciada'
        },
        component: () => import(/* webpackChunkName: "users-add" */ '@/views/main/settings/test-registers/garageaccredited/Add.vue')
      },
      {
        path: '/main/garageaccredited/:id',
        name: 'editgarageaccredited',
        meta: {
          tag: 'edit_garageaccredited',
          menu: 'settings',
          name: 'Editar | Oficina Credenciada',
          breadcrumb: 'Editar Oficina Credenciada'
        },
        component: () => import(/* webpackChunkName: "users-edit" */ '@/views/main/settings/test-registers/garageaccredited/Edit.vue')
      }
    ]
  },
]
